/**
 * Copyright © PlanMaster Fogászati Szoftver Kft. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Tamas Neufeld <tamas.neufeld@planmaster3d.com>, 2018
 */


export default {

    namespaced: true,

    state: {
        _debug: true,
        visible: false,
        items: [],
        active: null,
        mobileVisible: true,
        key: 0,
    },

    getters: {
        items: function(state, getters, rootState, rootGetters) {
            return function() {
                return Array.isArray(state.items) ? state.items : [];
            };
        },
    },

    mutations: {
        /**
         *
         * @param state
         * Use: store.commit('navbar/toggle');
         */
        toggle: function(state) {
            state.mobileVisible = !state.mobileVisible;
            app.$bus.$emit('navbar:toggled');
        },

        /**
         *
         * @param state
         * @param params
         * Use: store.commit('navbar/hide');
         */
        hide: function(state) {
            state.visible = false;
        },

        /**
         *
         * @param state
         * @param params
         * Use: store.commit('navbar/show');
         */
        show: function(state) {
            state.visible = true;
        },

        /**
         *
         * @param state
         * @param items
         * Use: store.commit('navbar/setItems',[]);
         */
        setItems: function(state, items) {
            state.items = items;
            //@todo: validate items
        },


        setActive: function (state, key) {
            state.active = key;
        },


        update: function (state, params) {
            state.items = params[0];
            state.active = typeof params[1] === 'string' ? params[1] : null;
            state.visible = true;
            state.key++;
        },

    },
};
